export default [
  {
    label: "Eastern Time (EST)",
    value: "America/New_York"
  },
  {
    label: "Central Time (CST)",
    value: "America/Chicago"
  },
  {
    label: "Mountain Time (MST)",
    value: "America/Denver"
  },
  {
    label: "Pacific Time (PST)",
    value: "America/Los_Angeles"
  },
  {
    label: "Alaska Time (AST)",
    value: "America/Anchorage"
  },
  {
    label: "Hawaii-Aleutian Time (HST)",
    value: "Pacific/Honolulu"
  }
];
